module.exports = __webpack_public_path__ + "img/icon_xuni(1).c624ec47.png";